import { FunctionComponent, useState } from "react";
import { Grid, TextField, Button, CircularProgress, IconButton, createStyles, makeStyles } from "@material-ui/core";
import file from "client-sdk/src/parcels/file";
import { Controller, useForm } from "react-hook-form";
import RonadIcons from "../../../components/iconComponent";
import handleNotfication from "../../../utils/handleNotification";
import handleError from "../../../utils/handleError";
import { createMessage } from "../../../api/ticket/create";
import { uploadTicketFile } from "../../../api/ticket/put";

interface AddMessageProps {
  id: string
  reloadPage: () => void
  ticket: any
}

const useStyles = makeStyles(theme =>
  createStyles({
    uploadInput: {
      display: 'none',
    },
    choosebtn: {
      marginLeft: "1rem",
      span: {
        'nth-child(1)': {
          backgroundColor: '#1976d2',
          color: '#fff',
        },
      },
    },
  })
);
 
const AddMessage: FunctionComponent<AddMessageProps> = ({id, reloadPage, ticket}) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<any>('');
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
  useForm({
    defaultValues: {
      file: null,
      subject: '1',
      msg: '',
    },
  });
  const classes = useStyles();
  const onSubmit = async (data: any) => {
    const body = {
      text: data.msg
    }
    try {
      setLoading(true);
      const res = await createMessage(body,id)
      handleNotfication('پیام با موفقیت ارسال شدند', 'success');
      setValue('msg', '');
      file && await uploadFile(file, res.data.id)
      reloadPage()
    } catch (err) {
      handleError(err);
    } finally {
      setFile(null);
      setLoading(false);
      setValue('file', null);
    }
  };
  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };
  const uploadFile = async (ticketFile: any, contentId: number) => {
    const form = new FormData()
    form.append('file', ticketFile)
    await uploadTicketFile(form, contentId,id)
  }
  return ( 
    <form onSubmit={handleSubmit(onSubmit)}>
    <Grid container direction="row" alignItems="center">
      <Grid item md={10} lg={10}>
        <Controller
          style={{ width: '100%', padding: '8px' }}
          control={control}
          name="msg"
          rules={{ required: true }}
          as={
            <TextField
              style={{ margin: 8 }}
              placeholder="پیام خود را بنویسید"
              fullWidth
              margin="none"
              InputLabelProps={{
                shrink: true,
              }}
            />
          }
        />
      </Grid>
      <Grid item md={1} lg={1}>
        <label htmlFor="file" className={classes.choosebtn}>
          <Button variant="contained" size="small" component="span" disabled={ticket?.creator.type !== 'FFC'}>
            انتخاب فایل
          </Button>
          <input
            id="file"
            type="file"
            name="file"
            disabled={ticket?.creator.type !== 'FFC'}
            ref={register}
            onChange={handleChangeFileInput}
            className={classes.uploadInput}
          />
        </label>
      </Grid>
      <Grid item md={1} lg={1}>
        <Button
          disabled={ticket?.creator.type !== 'FFC'}
          type="submit"
          variant="outlined"
          size="small"
          color="primary"
          style={{ marginLeft: '24px' }}
        >
          {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
        </Button>

      </Grid>
      {file && (
        <Grid
          style={{
            textAlign: 'left',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <IconButton
            style={{ marginLeft: 'auto' }} 
            onClick={handleRemoveFile}
          >
            <RonadIcons name="x-close"  size="20px"/>
          </IconButton>
          <span style={{ marginTop: '14px' }}>
            <span style={{ fontWeight: 'bold' }}> {file.name} </span>
            <span>( {file.size} KB )</span>
          </span>
        </Grid>
      )}
    </Grid>
  </form>
  );
}
 
export default AddMessage;
